<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear absolute color="success" height="4" indeterminate></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="crm-color" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ $t("DEAL_STATUSES.VIEW") }}</v-toolbar-title>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <div class="preview-list">
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.ID") }}:</span>
                  <span class="preview-value">{{ requestData.id || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.NAME") }}:</span>
                  <span class="preview-value">{{ requestData.name || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("DEAL_STATUSES.SLUG") }}:</span>
                  <span class="preview-value">{{ requestData.slug || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("DEAL_STATUSES.TYPE") }}:</span>
                  <span class="preview-value">
                    <v-chip x-small :color="requestData.is_system ? 'primary' : 'grey'" dark>
                      {{ requestData.is_system ? $t("DEAL_STATUSES.SYSTEM") : $t("DEAL_STATUSES.CUSTOM") }}
                    </v-chip>
                  </span>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="hasPermissions('deal-statuses-edit') && !requestData.is_system"
                color="primary"
                class="mr-2"
                :to="{ name: 'deal-statuses-edit', params: { id: requestData.id || $route.params.id } }"
              >
                {{ $t("GENERAL.LABELS.EDIT_BUTTON") }}
              </v-btn>
              <v-btn
                v-if="canDelete"
                color="error"
                class="mr-2"
                @click="deleteConfirm = true"
              >
                {{ $t("GENERAL.LABELS.DELETE") }}
              </v-btn>
              <v-btn color="warning" @click="back">{{ $t("GENERAL.LABELS.BACK_BUTTON") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <Confirm
      v-model="deleteConfirm"
      :content="$t('GENERAL.DELETE_CONFIRM')"
      @confirm="deleteDealStatus"
      @decline="deleteConfirm = false"
    />
  </div>
</template>

<script>
import { GET_DEAL_STATUS, DELETE_DEAL_STATUS } from "@/store/dealStatuses.module";
import { SHOW_SNACK } from "@/store/snack.module";
import Confirm from "@/views/partials/dialogs/Confirm.vue";

export default {
  name: "ViewDealStatus",
  components: {
    Confirm,
  },
  data() {
    return {
      tab: "tab-1",
      isProcessing: false,
      deleteConfirm: false,
      requestData: {},
    };
  },
  computed: {
    canDelete() {
      return this.hasPermissions("deal-statuses-delete")
        && this.requestData.id
        && !this.requestData.is_system;
    },
  },
  mounted() {
    this.loadItem();
  },
  methods: {
    back() {
      this.$router.push({ name: "deal-statuses" });
    },
    loadItem() {
      this.isProcessing = true;
      this.$store
        .dispatch(GET_DEAL_STATUS, this.$route.params.id)
        .then((response) => {
          this.requestData = response || {};
        })
        .catch(() => {
          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.UNEXPECTED_ERROR"),
            type: "error",
          });
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    getErrorMessage(error) {
      if (error && error.errors && typeof error.errors === "object") {
        const firstErrorField = Object.keys(error.errors)[0];
        const firstErrorList = error.errors[firstErrorField];

        if (Array.isArray(firstErrorList) && firstErrorList.length) {
          return firstErrorList[0];
        }
      }

      if (error && error.message) {
        return error.message;
      }

      return this.$t("GENERAL.UNEXPECTED_ERROR");
    },
    deleteDealStatus() {
      this.isProcessing = true;
      this.$store
        .dispatch(DELETE_DEAL_STATUS, this.requestData.id || this.$route.params.id)
        .then(() => {
          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.SUCCESS_MESSAGE"),
          });
          this.back();
        })
        .catch((error) => {
          this.$store.dispatch(SHOW_SNACK, {
            type: "error",
            message: this.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.isProcessing = false;
          this.deleteConfirm = false;
        });
    },
  },
};
</script>
